import * as React from 'react';

import { GoogleBanner, GwGHelpBanner, LearnerProgramHomeBanner } from '@coursera-web/enterprise-admin-grow-with-google';

import user from 'js/lib/user';

const GoogleProgramBannerModuleNotConfigurable = () => {
  return (
    <React.Fragment>
      <GwGHelpBanner isAuthenticatedUser={user.isAuthenticatedUser()} />
      <LearnerProgramHomeBanner />
      <GoogleBanner />
    </React.Fragment>
  );
};

export default GoogleProgramBannerModuleNotConfigurable;
